export const PROJECT_TAB_ALL = 'all';
export const PROJECT_TAB_NEW = 'new';
export const PROJECT_TAB_IN_WORK = 'inwork';
export const PROJECT_TAB_ARCHIVE = 'archive';
export const PROJECT_TAB_PORTFOLIO = 'portfolio';
